<template>
<div>
  <Head></Head>
  <div class="me-center">
    <div class="l-center">
      <van-field
        v-model.trim="mobile"
        label="手机号"
        placeholder="请输入手机号"
        required
      />
      
      <van-field
        v-model.trim="password"
        label="密码"
        placeholder="请输入密码"
        type="password"
        required
      />
      
      <van-field
        v-model.trim="qrpassword"
        label="密码确认"
        placeholder="请再次输入密码"
        type="password"
        required
      />
      
      <van-cell-group>
        <van-field
          v-model="sms"
          center
          clearable
          label="短信验证码"
          placeholder="请输入短信验证码"
          required
        >
          <van-button  v-show="sendAuthCode" slot="button" size="small" type="danger" @click="sendsms">发送验证码</van-button>
          <van-button  v-show="!sendAuthCode" slot="button" disabled size="small" type="danger" >{{auth_time}}秒</van-button>
          
        </van-field>
      </van-cell-group>
      
      <div class="mespan">
        <span @click="dl">已有账号？点击登录</span>
      </div>
    
    <van-button size="normal" :block="true" class="loginbtn" type="danger" @click="loginsub">立即注册</van-button>
    
    </div>
  </div>
</div>
</template>

<script>
  import Head from '@/components/Head.vue'
  import md5 from 'js-md5'
  export default {
	metaInfo: {
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0, viewport-fit=cover' }
      ]
    },
    data(){
      return{
        src:require('../assets/1.jpg'),
        mobile:'',
        password:'',
        qrpassword:'',
        sms:'',
        sendAuthCode:true,
        auth_time: 0
      }
    },
    components: {
      Head
    },
    methods:{
      getAuthCode(){
        this.sendAuthCode = false;
        this.auth_time = 60;
        var auth_timetimer =  setInterval(()=>{
            this.auth_time--;
            if(this.auth_time<=0){
                this.sendAuthCode = true;
                clearInterval(auth_timetimer);
            }
        }, 1000);
      },
      sendsms(){
        if(this.mobile==''){
          this.$toast('请输入手机号码')
          return false
        }
        this.getAuthCode()
        this.$http.post(this.$burl+'&c=movient&m=getyzm',{mobile:this.mobile})
        .then(()=>{
          
        }).catch(()=>{})
      },
      loginsub(){
        let mobile=this.mobile
        let password=this.password
        let qrpassword=this.qrpassword
        let sms=this.sms
        
        if(mobile==''||password==''||qrpassword==''){
          this.$toast('请填写相关信息')
          return false
        }
        if(sms==''){
          this.$toast('请输入验证码')
          return false
        }
        if(password!=qrpassword){
          this.$toast('两次密码输入须一致')
          return false
        }
        
        password=md5(password+'movie')
        
        this.$http.post(this.$burl+'&c=login&m=realregister',{mobile:mobile,password:password,sms:sms})
        .then(()=>{
          this.$dialog.alert({
            message: '注册成功！'
          }).then(() => {
            this.dl()
          });
          
        }).catch(()=>{})
      },
      dl(){
        this.$router.push({name: 'login',replace:true})
      }
    }
  }
</script>

<style>
body{
  background-color: #fff;
}
.l-center{
  padding-top: 15%;
  padding-left: 10px;
  padding-right: 10px;
}
.loginbtn{
  width: 100%;
  display: block;
  margin-top: 50%;
}
.mespan{
  margin-top: 20px;
}
.mespan span{
  font-size: 14px;
  margin-right: 5px;
  margin-left: 14px;
  color: gray;
}
</style>